<template>
  <div class="w-100">
    <BCol cols="12">
      <BFormGroup label="ویدیو های کلاس" label-for="videoFile">
        <BFormFile
          ref="videoInput"
          id="videoFile"
          multiple
          @input="checkVideoSize"
          accept=".mp4, .mov, .mpeg, .mkv"
        ></BFormFile>
      </BFormGroup>
      <BRow
        v-if="videoFilesConcated && videoFilesConcated.length > 0"
        class="my-2"
      >
        <BCol
          cols="4"
          v-for="(item, index) in videoFilesConcated"
          :key="`video${index}`"
          style="width: 100%"
        >
          <BOverlay :show="isLoading">
            <div
              class="position-relative p-1 border rounded-lg shadow-sm mt-1"
              style="max-height: 240px; min-height: 240px"
            >
              <video
                height="170px"
                preload="metadata"
                class="rounded-lg"
                controls
                :src="handleMediaView(item)"
                style="width: 100%; max-height: 17rem"
              ></video>

              <div class="w-100 mt-1">
                <div
                  class="actions d-flex align-items-center justify-content-between mt-1"
                >
                  <div
                    v-if="item && item.mediaId"
                    class="actions d-flex align-items-center justify-content-between"
                  >
                    <!-- @click="createArvanVideo(item)" -->
                    <BButton
                      @click="renderVideoTitleModal(item)"
                      variant="info"
                      size="sm"
                      v-if="!item.arvanCloudVideoId"
                    >
                      محافظت از ویدیو
                    </BButton>
                    <!-- :variant="
                        item.arvanCloudVideoId && !item.arvanCloudPlayerUrl
                          ? 'info'
                          : 'success'
                      " -->
                    <BBadge
                      v-if="item.arvanCloudVideoId"
                      size="sm"
                      pill
                      class="font-weight-normal"
                      variant="transparent"
                      :class="
                        item.arvanCloudVideoId && !item.arvanCloudPlayerUrl
                          ? 'border-info text-info'
                          : 'border-success text-success'
                      "
                    >
                      {{
                        item.arvanCloudVideoId && !item.arvanCloudPlayerUrl
                          ? "در حال تبدیل"
                          : "محافظت شده"
                      }}
                    </BBadge>
                  </div>
                  <BBadge
                    v-if="!item.mediaId"
                    pill
                    size="sm"
                    class="font-weight-normal text-warning border-warning"
                    variant="transparent"
                  >
                    ذخیره نشده
                  </BBadge>
                  <feather-icon
                    icon="Trash2Icon"
                    size="20"
                    class="text-danger cursor-pointer"
                    @click="deleteVideo(item)"
                  />
                </div>
              </div>
            </div>
          </BOverlay>
        </BCol>
      </BRow>
    </BCol>
    <BCol cols="12">
      <BFormGroup label="عکس های کلاس" label-for="picFile">
        <BFormFile
          ref="imageInput"
          id="picFile"
          @input="emitImages"
          multiple
          accept=".jpg, .jpeg, .png"
        ></BFormFile>
      </BFormGroup>
      <BRow
        v-if="imageFilesConcated && imageFilesConcated.length > 0"
        class="my-2"
        style="grid-gap: 1rem 0"
      >
        <BCol
          cols="4"
          v-for="(item, index) in imageFilesConcated"
          :key="`image${index}`"
          class="position-relative"
          style="width: 100%"
        >
          <img
            :src="handleMediaView(item)"
            style="width: 100%; max-height: 25rem; object-fit: contain"
          />
          <feather-icon
            icon="Trash2Icon"
            size="25"
            class="text-danger position-absolute"
            style="left: 1.3rem; top: 1rem; cursor: pointer"
            @click="deletePicture(item.pictureUrl)"
          />
        </BCol>
      </BRow>
    </BCol>
    <BCol cols="12">
      <BFormGroup label="پادکست های کلاس" label-for="audioFile">
        <BFormFile
          ref="audioInput"
          id="audioFile"
          @input="emitAudios"
          multiple
          accept=".mp3, .wav"
        ></BFormFile>
      </BFormGroup>
      <BRow
        v-if="audioFilesConcated && audioFilesConcated.length > 0"
        class="my-2"
        style="grid-gap: 1rem 0"
      >
        <BCol
          cols="4"
          v-for="(item, index) in audioFilesConcated"
          :key="`audio${index}`"
          class="position-relative"
          style="width: 100%"
        >
          <div class="d-flex flex-column align-items-center">
            <div class="d-flex justify-content-center">
              <p class="mb-0">{{ item.name }}</p>
              <feather-icon
                icon="Trash2Icon"
                size="20"
                class="text-danger ml-1"
                style="cursor: pointer"
                @click="deleteAudio(item.pictureUrl)"
              />
            </div>
            <audio controls :src="handleMediaView(item)"></audio>
          </div>
        </BCol>
      </BRow>
    </BCol>
    <BCol cols="12">
      <BFormGroup label="مقاله های کلاس" label-for="textFile">
        <BFormFile
          ref="textInput"
          id="textFile"
          @input="emitTexts"
          multiple
          accept=".docs, .pdf, .txt, .docx"
        ></BFormFile>
      </BFormGroup>
      <BRow
        v-if="textFilesConcated && textFilesConcated.length > 0"
        class="my-2"
        style="grid-gap: 1rem 0"
      >
        <BCol
          cols="3"
          v-for="(item, index) in textFilesConcated"
          :key="`text${index}`"
          class="position-relative"
          style="width: 100%"
        >
          <div
            class="shadow-lg p-1 rounded-lg d-flex flex-column align-items-center justify-content-between"
          >
            <feather-icon icon="BookOpenIcon" size="20" />
            <TextInput
              v-model="item.title"
              size="sm"
              :disabled="item.mediaId ? true : false"
              inputId="title"
              inputLabel="عنوان فایل"
              inputPlaceholder="American Family"
            ></TextInput>
            <BButton
              size="sm"
              @click="handleTextMedia(item)"
              :variant="item.mediaId ? 'primary' : 'success'"
              class="mb-1"
            >
              مشاهده فایل
            </BButton>
            <feather-icon
              icon="Trash2Icon"
              size="20"
              class="text-danger"
              style="cursor: pointer"
              @click="deleteText(item.pictureUrl)"
            />
          </div>
        </BCol>
      </BRow>
    </BCol>
    <BModal
      title="عنوان ویدیو"
      id="modal-video-title"
      centered
      ok-title="ثبت"
      cancel-title="بستن"
      @ok="createArvanVideo"
      :ok-disabled="!tempVideoObject.title"
    >
      <BContainer fluid>
        <BFormRow>
          <BCol cols="12">
            <BFormGroup label="عنوان ویدیو" label-for="video-title">
              <BFormInput
                v-model="tempVideoObject.title"
                size="sm"
                id="video-title"
                placeholder="آیلتس 1"
              ></BFormInput>
            </BFormGroup>
          </BCol>
        </BFormRow>
      </BContainer>
    </BModal>
  </div>
</template>
<script>
export default {
  emits: [
    "deleteVideo",
    "getVideoArray",
    "deletePicture",
    "getImageArray",
    "getAudioArray",
    "deleteAudio",
    "getTextArray",
    "deleteText",
    "refetch",
  ],
  props: {
    textFilesConcated: {
      type: Array,
    },
    audioFilesConcated: {
      type: Array,
    },
    imageFilesConcated: {
      type: Array,
    },
    videoFilesConcated: {
      type: Array,
    },
  },
  data() {
    return {
      isLoading: false,
      tempVideoObject: {
        title: null,
        description: null,
        mediaId: null,
      },
    };
  },
  methods: {
    renderVideoTitleModal(media) {
      this.tempVideoObject.mediaId = media.mediaId;
      this.$bvModal.show("modal-video-title");
    },
    closeRenderVideoModal() {
      this.$bvModal.hide("modal-video-title");
    },
    async createArvanVideo() {
      try {
        this.isLoading = true;
        let _this = this;
        let createArvanVideo = new CreateArvanVideo(_this);
        createArvanVideo.setRequestParam(_this.tempVideoObject);
        await createArvanVideo.fetch((response) => {
          if (
            response.message &&
            response.message == "video created successfully."
          ) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویدیو در صف تبدیل قرار گرفت.",
                icon: "EditIcon",
                variant: "success",
              },
            });

            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش در سرور پیش آمده، لطفا دوباره امتحان کنید.",
                icon: "EditIcon",
                variant: "danger",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.tempVideoObject = {
          title: null,
          description: null,
          mediaId: null,
        };
        this.isLoading = false;
      }
    },
    checkVideoSize(files) {
      this.emitVideos(files);
    },
    deleteText(text) {
      this.$emit("deleteText", text);
    },
    handleTextMedia(item) {
      window.open(this.handleMediaView(item.file));
    },
    emitTexts(files) {
      if (files && files.length > 0) {
        this.$emit("getTextArray", files);
      }
    },
    deleteAudio(audio) {
      this.$emit("deleteAudio", audio);
    },
    emitAudios(files) {
      if (files && files.length > 0) {
        this.$emit("getAudioArray", files);
      }
    },
    emitVideos(files) {
      if (files && files.length > 0) {
        this.$emit("getVideoArray", files);
      }
    },
    deleteVideo(video) {
      this.$emit("deleteVideo", video);
    },
    deletePicture(image) {
      this.$emit("deletePicture", image);
    },
    emitImages(files) {
      if (files && files.length > 0) {
        this.$emit("getImageArray", files);
      }
    },
    handleMediaView(file) {
      // Deciding whether file is blob or url
      if (file && file.mediaId) {
        return `${this.baseUrl}/${file.pictureUrl}`;
      } else if (file.File) {
        return URL.createObjectURL(file.File);
      }
    },
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  components: {
    BContainer,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormRow,
    BButton,
    BBadge,
    BOverlay,
    BModal,
    TextInput,
  },
};
import {
  BContainer,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormFile,
  BFormRow,
  BButton,
  BBadge,
  BOverlay,
  BModal,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { CreateArvanVideo } from "@/libs/Api/ArvanCloud";
import TextInput from "@/views/components/Utils/TextInput.vue";
</script>
